import axios from "axios";
import sessionHelper from "./sessionHelper";
import routesMap from "./routesMap";
// const siteUrl = 'http://shepa.ca-language.com/api/
//const siteUrl = routesMap.admin;
const siteUrl = process.env.VUE_APP_BASE_URL;
const siteUrl_wapi = process.env.VUE_APP_MERCHANT_BASE_URL;
class HttpHelper {
  config = {
    baseURL: siteUrl,
    timeout: 60000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  constructor() {}
  getData(url) {
    if (url.startsWith("~")) {
      url = url.replace("~", "");

      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : routesMap.base;
      url = this.config.baseURL + url;
    } else {
      this.config.baseURL = siteUrl;
      url = this.config.baseURL + "/" + url;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, this.config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          this.error = true;
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        })
        .then(() => {
          this.loading = false;
        });
    });
  }
  setAuth() {
    return (this.config.headers.Authorization =
      "Bearer " + sessionHelper.getUser().token);
  }
  postData(url, dataToSend) {
    if (url.startsWith("~")) {
      url = url.replace("~", "");
      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : this.baseURL;
      url = this.config.baseURL + url;
    } else {
      this.config.baseURL = siteUrl;
      url = this.config.baseURL + "/" + url;
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: url,
        headers: this.config.headers,
        data: dataToSend,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }
  PutData(url, dataToSend) {
    if (url.startsWith("~")) {
      url = url.replace("~", "");
      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : this.baseURL;
      url = this.config.baseURL + url;
    } else {
      this.config.baseURL = siteUrl;
      url = this.config.baseURL + "/" + url;
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: url,
        headers: this.config.headers,
        data: dataToSend,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }

  DeleteData(url, dataToSend) {
    if (url.startsWith("~")) {
      url = url.replace("~", "");
      this.config.baseURL = siteUrl_wapi ? siteUrl_wapi : this.baseURL;
      url = this.config.baseURL + url;
    } else {
      this.config.baseURL = siteUrl;
      url = this.config.baseURL + "/" + url;
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        url: url,
        headers: this.config.headers,
        data: dataToSend,
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }
  UploadFile(file) {
    var url = (siteUrl.endsWith("/") ? siteUrl : siteUrl + "/") + "upload";
    let formData = new FormData();
    formData.append("file", file);
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + sessionHelper.getUser().token,
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        });
    });
  }
  patchData(url, payload) {
    url = (siteUrl.endsWith("/") ? siteUrl : siteUrl + "/") + url;
    return new Promise((resolve, reject) => {
      axios
        .patch(url, payload, this.config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          this.error = true;
          if (error.response.status == 401) {
            window.location = "/";
          }
          reject(error);
        })
        .then(() => {
          this.loading = false;
        });
    });
  }
  getImage(id) {
    return this.getData("~api/files/" + id)
      .then((ImageUrl) => {
        return ImageUrl;
      })
      .catch(() => {
        return "";
      });
  }
}
const httpHelper = new HttpHelper();
export default httpHelper;
